// index.js ou App.js
import React from 'react';
import { createRoot } from 'react-dom/client'; 
import './styles/_index.scss';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './app/store';

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
